import { LanguageType, ThemeType } from '@app/types/app';

const THEME_STORAGE_KEY = 'theme';
const LANGUAGE_STORAGE_KEY = 'lng';

const isBrowser = () => typeof window !== 'undefined';

const readEnumValue = <T extends string>(
  key: string,
  allowedValues: readonly T[],
  fallback: T
): T => {
  if (!isBrowser()) return fallback;

  const value = window.localStorage.getItem(key);
  return value && allowedValues.includes(value as T) ? (value as T) : fallback;
};

const writeValue = (key: string, value: string): void => {
  if (!isBrowser()) return;
  window.localStorage.setItem(key, value);
};

export const readThemePreference = (fallback: ThemeType): ThemeType =>
  readEnumValue(THEME_STORAGE_KEY, ['light', 'dark', 'cnh'], fallback);

export const writeThemePreference = (theme: ThemeType): void => {
  writeValue(THEME_STORAGE_KEY, theme);
};

export const readLanguagePreference = (
  fallback: LanguageType = 'br'
): LanguageType =>
  readEnumValue(LANGUAGE_STORAGE_KEY, ['br', 'en', 'es'], fallback);

export const writeLanguagePreference = (language: LanguageType): void => {
  writeValue(LANGUAGE_STORAGE_KEY, language);
};
